import React, { useId } from 'react'
import styled from 'styled-components'
import SolidSparklesIcon from 'LuxKit/Icons/solid/SolidSparklesIcon'
import type { SvgIconProps } from 'LuxKit/SvgIcon'

/**
 * Hidden SVG container for gradient definitions.
 * Unlike text (which can use CSS background-clip: text), SVG paths only accept
 * solid colors or url(#id) references for fills. CSS gradients don't work on SVG fill.
 * We define the gradient here and reference it via fill="url(#gradient-id)".
 *
 * CSS custom properties are used for stop-color to maintain theme consistency.
 */
const GradientDefs = styled.svg`
  position: absolute;
  width: 0;
  height: 0;
  overflow: hidden;

  --ai-light: ${props => props.theme.palette.product.ai.light};
  --ai-dark: ${props => props.theme.palette.product.ai.dark};
`

const Container = styled.span`
  display: inline-flex;
  position: relative;
`

type Props = Pick<SvgIconProps, 'size'>

function AISparkleIcon(props: Props) {
  const { size = 'S' } = props
  const gradientId = useId()

  return (
    <Container>
      <GradientDefs aria-hidden="true">
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="var(--ai-light)" />
            <stop offset="100%" stopColor="var(--ai-dark)" />
          </linearGradient>
        </defs>
      </GradientDefs>
      <SolidSparklesIcon size={size} fill={`url(#${gradientId})`} />
    </Container>
  )
}

export default AISparkleIcon
